var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter"},[(_vm.list.length)?_c('marquee',_vm._l((_vm.list),function(item){return _c('span',{key:item.phone},[_vm._v("\n            恭喜血裔 "+_vm._s(item.phone)+" 获得【"+_vm._s(_vm._f("rewardNameFilter")(item))+"*"+_vm._s(item.itemcount)+"】\n        ")])}),0):_c('div',{staticClass:"blank"},[_vm._v("暂时没有任何动态消息")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }